import React, { Component } from "react";
// import Loading from "./Loading";
import SmoAuth from "../api/smo-auth";
import { withRouter } from "react-router-dom";
import { setAuthentication } from "../utils/auth-utils";

function isValidEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

class Auth extends Component {
  constructor(props) {
    super(props);

    this.smoAuth = new SmoAuth();

    this.state = {
      email: "",
      password: "",
      errorMessage: undefined,
      loading: false,
    };
  }

  isValid = () => {
    return isValidEmail(this.state.email) && this.state.password.length > 0;
  };

  onLogin = () => {
    this.setState({ loading: true });

    const smoAuth = new SmoAuth();
    smoAuth
      .signInAndGetToken(this.state.email.toLowerCase(), this.state.password)
      .then((token) => {
        setAuthentication({
          email: this.state.email,
          token: token,
        });

        this.setState({ loading: false, errorMessage: undefined });
        this.props.history.push("/");
      })
      .catch((err) => {
        switch (err.code) {
          case "UserNotFoundException":
            this.setState({
              errorMessage:
                "Invalid credentials. Please contact the application administrator.",
              loading: false,
            });
            break;
          case "NotAuthorizedException":
            this.setState({
              errorMessage:
                "Invalid credentials. Please contact the application administrator.",
              loading: false,
            });
            break;
          default:
            this.setState({
              errorMessage: "An error occured. Please try again.",
              loading: false,
            });
        }
      });
  };

  render() {
    
    const renderError = () => {
      if (this.state.errorMessage)
        return (
          <p className="mt-6 has-text-centered text has-text-danger">
            <small>{this.state.errorMessage}</small>
          </p>
        );
    };

    return (
      <>
        <section className="section columns mx-4 is-centered">
          <div className="container">
            <section className="section mx-6">
              <div className="container sie-title-container">
                <h4 className="title">
                  Siemens Mobility Instant Communication
                </h4>
                <h5 className="subtitle">Login</h5>
              </div>
            </section>

            <section className="section columns mx-6 is-centered">
              <div className="container ">
                <div className="field ">
                  <p className="control has-text-centered">
                    <input
                      className="input "
                      type="email"
                      placeholder="Email"
                      value={this.state.email}
                      onChange={(e) => this.setState({ email: e.target.value })}
                    />
                  </p>
                </div>
                <div className="field">
                  <p className="control has-text-centered">
                    <input
                      className="input"
                      type="password"
                      placeholder="Password"
                      value={this.state.password}
                      onChange={(e) =>
                        this.setState({ password: e.target.value })
                      }
                      onKeyDown={(e) => {
                        e.key === "Enter" && this.isValid() && this.onLogin();
                      }}
                    />
                  </p>
                </div>

                {renderError()}

                <div className="field">
                  <div className="buttons is-centered mt-6">
                    <button
                      className={`button is-primary ${
                        this.state.loading ? "is-loading" : ""
                      }`}
                      onClick={this.onLogin}
                      disabled={!this.isValid()}
                    >
                      Login
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </>
    );
  }
}

export default withRouter(Auth);
